import { Routes } from '@angular/router';
import { DomainAuthGuard } from './core/guards/domain-auth.guard';

// Auth Domain Routes (login.admaxhub.com, join.admaxhub.com)
export const authRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./auth/auth.component').then(m => m.AuthComponent),
    canActivate: [DomainAuthGuard],
    children: [
      {
        path: 'login',
        loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent)
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('./auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
      },
      {
        path: 'reset-password/:token',
        loadComponent: () => import('./auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
      },
      {
        path: 'confirmation',
        loadComponent: () => import('./auth/sign-up/confirmation/confirmation.component').then(m => m.ConfirmationComponent),
        canActivate: [DomainAuthGuard],
        children: [
          {
            path: 'email',
            loadComponent: () => import('./auth/sign-up/confirmation/email/email.component').then(m => m.EmailComponent)
          },
          {
            path: 'otp',
            loadComponent: () => import('./auth/sign-up/confirmation/otp/otp.component').then(m => m.OtpComponent)
          }
        ]
      },
      {
        path: 'category',
        loadComponent: () => import('./auth/sign-up/select-category/select-category.component').then(m => m.SelectCategoryComponent)
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      }
    ]
  }
];

export const joinRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./auth/auth.component').then(m => m.AuthComponent),
    canActivate: [DomainAuthGuard],
    children: [{
        path: 'register',
        loadComponent: () => import('./auth/sign-up/sign-up.component').then(m => m.SignUpComponent)
      },
      {
        path: 'category',
        loadComponent: () => import('./auth/sign-up/select-category/select-category.component').then(m => m.SelectCategoryComponent)
      },
      {
        path: 'profiling',
        loadComponent: () => import('./auth/profiling/profiling.component').then(m => m.ProfilingComponent)
      },
      {
        path: 'tnc',
        loadComponent: () => import('./shared/tnc/tnc.component').then(m => m.TncComponent)
      },
      {
        path: 'privacy-policy',
        loadComponent: () => import('./shared/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
      },
      {
        path: '',
        redirectTo: 'register',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'confirmation',
    loadComponent: () => import('./auth/sign-up/confirmation/confirmation.component').then(m => m.ConfirmationComponent),
    canActivate: [DomainAuthGuard],
    children: [
      {
        path: 'email',
        loadComponent: () => import('./auth/sign-up/confirmation/email/email.component').then(m => m.EmailComponent)
      },
      {
        path: 'otp',
        loadComponent: () => import('./auth/sign-up/confirmation/otp/otp.component').then(m => m.OtpComponent)
      }
    ]
  }
];

// DSP Domain Routes (dsp.admaxhub.com)
export const dspRoutes: Routes = [
  {
    path: 'main',
    loadComponent: () => import('./main/main.component').then(m => m.MainComponent),
    canActivate: [DomainAuthGuard],
    children: [
      {
        path: 'welcome',
        loadComponent: () => import('./main/welcome/welcome.component').then(m => m.WelcomeComponent)
      },
      {
        path: 'campaign',
        loadComponent: () => import('./main/campaign/campaign.component').then(m => m.CampaignComponent)
      },
      {
        path: 'screen-catalog',
        loadComponent: () => import('./main/campaign/screen-catalog/screen-catalog.component').then(m => m.ScreenCatalogComponent)
      },
      {
        path: 'advance-catalog',
        loadComponent: () => import('./main/campaign/advance-catalog/advance-catalog.component').then(m => m.AdvanceCatalogComponent)
      },
      {
        path: 'spots/:id',
        loadComponent: () => import('./main/campaign/spots-catalog/spots-detail/spots-detail.component').then(m => m.SpotsDetailComponent)
      },
      {
        path: 'inventory',
        loadComponent: () => import('./main/inventory/inventory.component').then(m => m.InventoryComponent),
        children: [
          {
            path: 'manage',
            loadComponent: () => import('./main/inventory/table/manage/manage.component').then(m => m.ManageComponent)
          },
          {
            path: 'need-attention',
            loadComponent: () => import('./main/inventory/table/need-attention/need-attention.component').then(m => m.NeedAttentionComponent)
          },
          {
            path: 'bookings',
            loadComponent: () => import('./main/inventory/table/bookings/bookings.component').then(m => m.BookingsComponent)
          },
          {
            path: 'performance',
            loadComponent: () => import('./main/inventory/table/performance/performance.component').then(m => m.PerformanceComponent)
          },
          {
            path: 'availability',
            loadComponent: () => import('./main/inventory/table/availability/availability.component').then(m => m.AvailabilityComponent)
          },
          {
            path: 'pricing',
            loadComponent: () => import('./main/inventory/table/pricing/pricing.component').then(m => m.PricingComponent)
          },
          {
            path: 'audience',
            loadComponent: () => import('./main/inventory/table/audience/audience.component').then(m => m.AudienceComponent)
          },
          {
            path: '',
            redirectTo: 'manage',
            pathMatch: 'full'
          }
        ]
      },
      {
        path: 'account',
        loadComponent: () => import('./main/menu-account/menu-account.component').then(m => m.MenuAccountComponent),
        children: [
          {
            path: 'license',
            loadComponent: () => import('./main/menu-account/license/license.component').then(m => m.LicenseComponent)
          },
          {
            path: 'settings',
            loadComponent: () => import('./main/menu-account/settings/settings.component').then(m => m.SettingsComponent),
            children: [
              {
                path: 'basic-info',
                loadComponent: () => import('./main/menu-account/settings/basic-info/basic-info.component').then(m => m.BasicInfoComponent)
              },
              {
                path: 'company',
                loadComponent: () => import('./main/menu-account/settings/company/company.component').then(m => m.CompanyComponent)
              },
              {
                path: 'payout',
                loadComponent: () => import('./main/menu-account/settings/payout/payout.component').then(m => m.PayoutComponent)
              },
              {
                path: '',
                redirectTo: 'basic-info',
                pathMatch: 'full'
              }
            ]
          },
          {
            path: 'user',
            loadComponent: () => import('./main/menu-account/user-management/user-management.component').then(m => m.UserManagementComponent)
          },
          {
            path: 'campaign',
            loadComponent: () => import('./main/menu-account/campaign-menu/campaign-menu.component').then(m => m.CampaignMenuComponent),
            children: [
              {
                path: 'create',
                loadComponent: () => import('./main/menu-account/campaign-menu/create/create.component').then(m => m.CreateComponent)
              },
              {
                path: 'edit',
                loadComponent: () => import('./main/menu-account/campaign-menu/edit/edit.component').then(m => m.EditComponent)
              },
              {
                path: 'drafts',
                loadComponent: () => import('./main/menu-account/campaign-menu/drafts/drafts.component').then(m => m.DraftsComponent)
              },
              {
                path: 'pending',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/pending.component').then(m => m.PendingComponent)
              },
              {
                path: 'pending/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/detail/pending-detail.component').then(m => m.PendingDetailComponent)
              },
              {
                path: 'running',
                loadComponent: () => import('./main/menu-account/campaign-menu/running/running.component').then(m => m.RunningComponent)
              },
              {
                path: 'running/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/detail/pending-detail.component').then(m => m.PendingDetailComponent)
              },
              {
                path: 'paused',
                loadComponent: () => import('./main/menu-account/campaign-menu/paused/paused.component').then(m => m.PausedComponent)
              },
              {
                path: 'paused/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/detail/pending-detail.component').then(m => m.PendingDetailComponent)
              },
              {
                path: 'failed',
                loadComponent: () => import('./main/menu-account/campaign-menu/failed/failed.component').then(m => m.FailedComponent)
              },
              {
                path: 'failed/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/detail/pending-detail.component').then(m => m.PendingDetailComponent)
              },
              {
                path: 'failed/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/detail/pending-detail.component').then(m => m.PendingDetailComponent)
              },
              {
                path: 'completed',
                loadComponent: () => import('./main/menu-account/campaign-menu/completed/completed.component').then(m => m.CompletedComponent)
              },
              {
                path: 'completed/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/completed/detail/completed-detail.component').then(m => m.CompletedDetailComponent)
              },
              {
                path: 'completed/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/completed/detail/completed-detail.component').then(m => m.CompletedDetailComponent)
              },
              {
                path: 'completed/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/completed/detail/completed-detail.component').then(m => m.CompletedDetailComponent)
              },
              {
                path: '',
                redirectTo: 'create',
                pathMatch: 'full'
              }
            ]
          },
        {
          path: 'campaign-wallet',
          loadComponent: () => import('./main/menu-account/campaign-wallet/campaign-wallet.component').then(m => m.CampaignWalletComponent)
        },
        {
          path: 'invoice',
          loadComponent: () => import('./main/menu-account/invoice/invoice.component').then(m => m.InvoiceComponent)
        },
        {
          path: 'invoice/detail/:id',
          loadComponent: () => import('./main/menu-account/invoice/invoice-detail/invoice-detail.component').then(m => m.InvoiceDetailComponent)
        },
          {
            path: 'inventory',
            loadComponent: () => import('./main/menu-account/inventory-menu/inventory-menu.component').then(m => m.InventoryMenuComponent),
            children: [
              {
                path: 'media-spot',
                loadComponent: () => import('./main/menu-account/inventory-menu/media-spot/media-spot.component').then(m => m.MediaSpotComponent)
              },
              {
                path: 'spot-group',
                loadComponent: () => import('./main/menu-account/inventory-menu/spot-group/spot-group.component').then(m => m.SpotGroupComponent)
              },
              {
                path: 'screen',
                loadComponent: () => import('./main/menu-account/inventory-menu/screens/screens.component').then(m => m.ScreensComponent)
              },
              {
                path: 'screen/:id/layout',
                loadComponent: () => import('./main/menu-account/inventory-menu/screens/screen-layout/screen-layout.component').then(m => m.ScreenLayoutComponent)
              },
              {
                path: 'bookings',
                loadComponent: () => import('./main/menu-account/inventory-menu/booking/booking.component').then(m => m.BookingComponent)
              },
              {
                path: '',
                redirectTo: 'media-spot',
                pathMatch: 'full'
              }
            ]
          },
          {
            path: 'subscription',
            loadComponent: () => import('./main/menu-account/subscription/subscription.component').then(m => m.SubscriptionComponent),
            children: [
              {
                path: 'active-plan',
                loadComponent: () => import('./main/menu-account/subscription/active-plan/active-plan.component').then(m => m.ActivePlanComponent)
              },
              {
                path: 'upgrade-plan',
                loadComponent: () => import('./main/menu-account/subscription/upgrade-plan/upgrade-plan.component').then(m => m.UpgradePlanComponent)
              },
              {
                path: 'my-order',
                loadComponent: () => import('./main/menu-account/subscription/my-order/my-order.component').then(m => m.MyOrderComponent)
              },
              {
                path: '',
                redirectTo: 'active-plan',
                pathMatch: 'full'
              }
            ]
          }
        ]
      },
      {
        path: '',
        redirectTo: 'welcome',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full'
  }
];

// SSP Domain Routes (ssp.admaxhub.com)
export const sspRoutes: Routes = [
  {
    path: 'main',
    loadComponent: () => import('./main/main.component').then(m => m.MainComponent),
    canActivate: [DomainAuthGuard],
    children: [
      {
        path: 'welcome',
        loadComponent: () => import('./main/welcome/welcome.component').then(m => m.WelcomeComponent)
      },
      {
        path: 'campaign',
        loadComponent: () => import('./main/campaign/campaign.component').then(m => m.CampaignComponent)
      },
      {
        path: 'screen-catalog',
        loadComponent: () => import('./main/campaign/screen-catalog/screen-catalog.component').then(m => m.ScreenCatalogComponent)
      },
      {
        path: 'advance-catalog',
        loadComponent: () => import('./main/campaign/advance-catalog/advance-catalog.component').then(m => m.AdvanceCatalogComponent)
      },
      {
        path: 'spots/:id',
        loadComponent: () => import('./main/campaign/spots-catalog/spots-detail/spots-detail.component').then(m => m.SpotsDetailComponent)
      },
      {
        path: 'inventory',
        loadComponent: () => import('./main/inventory/inventory.component').then(m => m.InventoryComponent),
        children: [
          {
            path: 'manage',
            loadComponent: () => import('./main/inventory/table/manage/manage.component').then(m => m.ManageComponent)
          },
          {
            path: 'need-attention',
            loadComponent: () => import('./main/inventory/table/need-attention/need-attention.component').then(m => m.NeedAttentionComponent)
          },
          {
            path: 'bookings',
            loadComponent: () => import('./main/inventory/table/bookings/bookings.component').then(m => m.BookingsComponent)
          },
          {
            path: 'performance',
            loadComponent: () => import('./main/inventory/table/performance/performance.component').then(m => m.PerformanceComponent)
          },
          {
            path: 'availability',
            loadComponent: () => import('./main/inventory/table/availability/availability.component').then(m => m.AvailabilityComponent)
          },
          {
            path: 'pricing',
            loadComponent: () => import('./main/inventory/table/pricing/pricing.component').then(m => m.PricingComponent)
          },
          {
            path: 'audience',
            loadComponent: () => import('./main/inventory/table/audience/audience.component').then(m => m.AudienceComponent)
          },
          {
            path: '',
            redirectTo: 'manage',
            pathMatch: 'full'
          }
        ]
      },
      {
        path: 'account',
        loadComponent: () => import('./main/menu-account/menu-account.component').then(m => m.MenuAccountComponent),
        children: [
          {
            path: 'license',
            loadComponent: () => import('./main/menu-account/license/license.component').then(m => m.LicenseComponent)
          },
          {
            path: 'settings',
            loadComponent: () => import('./main/menu-account/settings/settings.component').then(m => m.SettingsComponent),
            children: [
              {
                path: 'basic-info',
                loadComponent: () => import('./main/menu-account/settings/basic-info/basic-info.component').then(m => m.BasicInfoComponent)
              },
              {
                path: 'company',
                loadComponent: () => import('./main/menu-account/settings/company/company.component').then(m => m.CompanyComponent)
              },
              {
                path: 'payout',
                loadComponent: () => import('./main/menu-account/settings/payout/payout.component').then(m => m.PayoutComponent)
              },
              {
                path: '',
                redirectTo: 'basic-info',
                pathMatch: 'full'
              }
            ]
          },
          {
            path: 'user',
            loadComponent: () => import('./main/menu-account/user-management/user-management.component').then(m => m.UserManagementComponent)
          },
          {
            path: 'campaign',
            loadComponent: () => import('./main/menu-account/campaign-menu/campaign-menu.component').then(m => m.CampaignMenuComponent),
            children: [
              {
                path: 'create',
                loadComponent: () => import('./main/menu-account/campaign-menu/create/create.component').then(m => m.CreateComponent)
              },
              {
                path: 'edit',
                loadComponent: () => import('./main/menu-account/campaign-menu/edit/edit.component').then(m => m.EditComponent)
              },
              {
                path: 'drafts',
                loadComponent: () => import('./main/menu-account/campaign-menu/drafts/drafts.component').then(m => m.DraftsComponent)
              },
              {
                path: 'pending',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/pending.component').then(m => m.PendingComponent)
              },
              {
                path: 'pending/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/detail/pending-detail.component').then(m => m.PendingDetailComponent)
              },
              {
                path: 'running',
                loadComponent: () => import('./main/menu-account/campaign-menu/running/running.component').then(m => m.RunningComponent)
              },
              {
                path: 'running/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/detail/pending-detail.component').then(m => m.PendingDetailComponent)
              },
              {
                path: 'paused',
                loadComponent: () => import('./main/menu-account/campaign-menu/paused/paused.component').then(m => m.PausedComponent)
              },
              {
                path: 'paused/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/detail/pending-detail.component').then(m => m.PendingDetailComponent)
              },
              {
                path: 'failed',
                loadComponent: () => import('./main/menu-account/campaign-menu/failed/failed.component').then(m => m.FailedComponent)
              },
              {
                path: 'failed/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/detail/pending-detail.component').then(m => m.PendingDetailComponent)
              },
              {
                path: 'completed',
                loadComponent: () => import('./main/menu-account/campaign-menu/completed/completed.component').then(m => m.CompletedComponent)
              },
              {
                path: 'completed/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/completed/detail/completed-detail.component').then(m => m.CompletedDetailComponent)
              },
              {
                path: '',
                redirectTo: 'create',
                pathMatch: 'full'
              }
            ]
          },
        {
          path: 'campaign-wallet',
          loadComponent: () => import('./main/menu-account/campaign-wallet/campaign-wallet.component').then(m => m.CampaignWalletComponent)
        },
        {
          path: 'invoice',
          loadComponent: () => import('./main/menu-account/invoice/invoice.component').then(m => m.InvoiceComponent)
        },
        {
          path: 'invoice/detail/:id',
          loadComponent: () => import('./main/menu-account/invoice/invoice-detail/invoice-detail.component').then(m => m.InvoiceDetailComponent)
        },
          {
            path: 'inventory',
            loadComponent: () => import('./main/menu-account/inventory-menu/inventory-menu.component').then(m => m.InventoryMenuComponent),
            children: [
              {
                path: 'media-spot',
                loadComponent: () => import('./main/menu-account/inventory-menu/media-spot/media-spot.component').then(m => m.MediaSpotComponent)
              },
              {
                path: 'spot-group',
                loadComponent: () => import('./main/menu-account/inventory-menu/spot-group/spot-group.component').then(m => m.SpotGroupComponent)
              },
              {
                path: 'screen',
                loadComponent: () => import('./main/menu-account/inventory-menu/screens/screens.component').then(m => m.ScreensComponent)
              },
              {
                path: 'screen/:id/layout',
                loadComponent: () => import('./main/menu-account/inventory-menu/screens/screen-layout/screen-layout.component').then(m => m.ScreenLayoutComponent)
              },
              {
                path: 'bookings',
                loadComponent: () => import('./main/menu-account/inventory-menu/booking/booking.component').then(m => m.BookingComponent)
              },
              {
                path: '',
                redirectTo: 'media-spot',
                pathMatch: 'full'
              }
            ]
          },
          {
            path: 'subscription',
            loadComponent: () => import('./main/menu-account/subscription/subscription.component').then(m => m.SubscriptionComponent),
            children: [
              {
                path: 'active-plan',
                loadComponent: () => import('./main/menu-account/subscription/active-plan/active-plan.component').then(m => m.ActivePlanComponent)
              },
              {
                path: 'upgrade-plan',
                loadComponent: () => import('./main/menu-account/subscription/upgrade-plan/upgrade-plan.component').then(m => m.UpgradePlanComponent)
              },
              {
                path: 'my-order',
                loadComponent: () => import('./main/menu-account/subscription/my-order/my-order.component').then(m => m.MyOrderComponent)
              },
              {
                path: '',
                redirectTo: 'active-plan',
                pathMatch: 'full'
              }
            ]
          }
        ]
      },
      {
        path: '',
        redirectTo: 'welcome',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full'
  }
];

// Development/Localhost Routes (semua fitur tersedia)
export const localhostRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./auth/auth.component').then(m => m.AuthComponent),
    children: [
      {
        path: 'login',
        loadComponent: () => import('./auth/login/login.component').then(m => m.LoginComponent)
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('./auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
      },
      {
        path: 'register',
        loadComponent: () => import('./auth/sign-up/sign-up.component').then(m => m.SignUpComponent)
      },
      {
        path: 'category',
        loadComponent: () => import('./auth/sign-up/select-category/select-category.component').then(m => m.SelectCategoryComponent)
      },
      {
        path: 'profiling',
        loadComponent: () => import('./auth/profiling/profiling.component').then(m => m.ProfilingComponent)
      },
      {
        path: 'tnc',
        loadComponent: () => import('./shared/tnc/tnc.component').then(m => m.TncComponent)
      },
      {
        path: 'privacy-policy',
        loadComponent: () => import('./shared/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
      },
      {
        path: 'reset-password/:token',
        loadComponent: () => import('./auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'confirmation',
    loadComponent: () => import('./auth/sign-up/confirmation/confirmation.component').then(m => m.ConfirmationComponent),
    children: [
      {
        path: 'email',
        loadComponent: () => import('./auth/sign-up/confirmation/email/email.component').then(m => m.EmailComponent)
      },
      {
        path: 'otp',
        loadComponent: () => import('./auth/sign-up/confirmation/otp/otp.component').then(m => m.OtpComponent)
      }
    ]
  },
  {
    path: 'main',
    loadComponent: () => import('./main/main.component').then(m => m.MainComponent),
    canActivate: [DomainAuthGuard],
    children: [
      {
        path: 'welcome',
        loadComponent: () => import('./main/welcome/welcome.component').then(m => m.WelcomeComponent)
      },
      {
        path: 'inventory',
        loadComponent: () => import('./main/inventory/inventory.component').then(m => m.InventoryComponent),
        children: [
          {
            path: 'manage',
            loadComponent: () => import('./main/inventory/table/manage/manage.component').then(m => m.ManageComponent)
          },
          {
            path: 'need-attention',
            loadComponent: () => import('./main/inventory/table/need-attention/need-attention.component').then(m => m.NeedAttentionComponent)
          },
          {
            path: 'bookings',
            loadComponent: () => import('./main/inventory/table/bookings/bookings.component').then(m => m.BookingsComponent)
          },
          {
            path: 'performance',
            loadComponent: () => import('./main/inventory/table/performance/performance.component').then(m => m.PerformanceComponent)
          },
          {
            path: 'availability',
            loadComponent: () => import('./main/inventory/table/availability/availability.component').then(m => m.AvailabilityComponent)
          },
          {
            path: 'pricing',
            loadComponent: () => import('./main/inventory/table/pricing/pricing.component').then(m => m.PricingComponent)
          },
          {
            path: 'audience',
            loadComponent: () => import('./main/inventory/table/audience/audience.component').then(m => m.AudienceComponent)
          },
          {
            path: '',
            redirectTo: 'manage',
            pathMatch: 'full'
          }
        ]
      },
      {
        path: 'campaign',
        loadComponent: () => import('./main/campaign/campaign.component').then(m => m.CampaignComponent)
      },
      {
        path: 'screen-catalog',
        loadComponent: () => import('./main/campaign/screen-catalog/screen-catalog.component').then(m => m.ScreenCatalogComponent)
      },
      {
        path: 'advance-catalog',
        loadComponent: () => import('./main/campaign/advance-catalog/advance-catalog.component').then(m => m.AdvanceCatalogComponent)
      },
      {
        path: 'spots/:id',
        loadComponent: () => import('./main/campaign/spots-catalog/spots-detail/spots-detail.component').then(m => m.SpotsDetailComponent)
      },
      {
        path: 'account',
        loadComponent: () => import('./main/menu-account/menu-account.component').then(m => m.MenuAccountComponent),
        children: [
          {
            path: 'license',
            loadComponent: () => import('./main/menu-account/license/license.component').then(m => m.LicenseComponent)
          },
          {
            path: 'settings',
            loadComponent: () => import('./main/menu-account/settings/settings.component').then(m => m.SettingsComponent),
            children: [
              {
                path: 'basic-info',
                loadComponent: () => import('./main/menu-account/settings/basic-info/basic-info.component').then(m => m.BasicInfoComponent)
              },
              {
                path: 'company',
                loadComponent: () => import('./main/menu-account/settings/company/company.component').then(m => m.CompanyComponent)
              },
              {
                path: 'payout',
                loadComponent: () => import('./main/menu-account/settings/payout/payout.component').then(m => m.PayoutComponent)
              },
              {
                path: '',
                redirectTo: 'basic-info',
                pathMatch: 'full'
              }
            ]
          },
          {
            path: 'user',
            loadComponent: () => import('./main/menu-account/user-management/user-management.component').then(m => m.UserManagementComponent)
          },
          {
            path: 'campaign',
            loadComponent: () => import('./main/menu-account/campaign-menu/campaign-menu.component').then(m => m.CampaignMenuComponent),
            children: [
              {
                path: 'create',
                loadComponent: () => import('./main/menu-account/campaign-menu/create/create.component').then(m => m.CreateComponent)
              },
              {
                path: 'edit',
                loadComponent: () => import('./main/menu-account/campaign-menu/edit/edit.component').then(m => m.EditComponent)
              },
              {
                path: 'drafts',
                loadComponent: () => import('./main/menu-account/campaign-menu/drafts/drafts.component').then(m => m.DraftsComponent)
              },
              {
                path: 'pending',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/pending.component').then(m => m.PendingComponent)
              },
              {
                path: 'pending/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/detail/pending-detail.component').then(m => m.PendingDetailComponent)
              },
              {
                path: 'running',
                loadComponent: () => import('./main/menu-account/campaign-menu/running/running.component').then(m => m.RunningComponent)
              },
              {
                path: 'running/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/detail/pending-detail.component').then(m => m.PendingDetailComponent)
              },
              {
                path: 'paused',
                loadComponent: () => import('./main/menu-account/campaign-menu/paused/paused.component').then(m => m.PausedComponent)
              },
              {
                path: 'paused/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/detail/pending-detail.component').then(m => m.PendingDetailComponent)
              },
              {
                path: 'failed',
                loadComponent: () => import('./main/menu-account/campaign-menu/failed/failed.component').then(m => m.FailedComponent)
              },
              {
                path: 'failed/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/pending/detail/pending-detail.component').then(m => m.PendingDetailComponent)
              },
              {
                path: 'completed',
                loadComponent: () => import('./main/menu-account/campaign-menu/completed/completed.component').then(m => m.CompletedComponent)
              },
              {
                path: 'completed/detail/:id',
                loadComponent: () => import('./main/menu-account/campaign-menu/completed/detail/completed-detail.component').then(m => m.CompletedDetailComponent)
              },
              {
                path: '',
                redirectTo: 'create',
                pathMatch: 'full'
              }
            ]
          },
        {
          path: 'campaign-wallet',
          loadComponent: () => import('./main/menu-account/campaign-wallet/campaign-wallet.component').then(m => m.CampaignWalletComponent)
        },
        {
          path: 'invoice',
          loadComponent: () => import('./main/menu-account/invoice/invoice.component').then(m => m.InvoiceComponent)
        },
        {
          path: 'invoice/detail/:id',
          loadComponent: () => import('./main/menu-account/invoice/invoice-detail/invoice-detail.component').then(m => m.InvoiceDetailComponent)
        },
          {
            path: 'inventory',
            loadComponent: () => import('./main/menu-account/inventory-menu/inventory-menu.component').then(m => m.InventoryMenuComponent),
            children: [
              {
                path: 'media-spot',
                loadComponent: () => import('./main/menu-account/inventory-menu/media-spot/media-spot.component').then(m => m.MediaSpotComponent)
              },
              {
                path: 'spot-group',
                loadComponent: () => import('./main/menu-account/inventory-menu/spot-group/spot-group.component').then(m => m.SpotGroupComponent)
              },
              {
                path: 'screen',
                loadComponent: () => import('./main/menu-account/inventory-menu/screens/screens.component').then(m => m.ScreensComponent)
              },
              {
                path: 'screen/:id/layout',
                loadComponent: () => import('./main/menu-account/inventory-menu/screens/screen-layout/screen-layout.component').then(m => m.ScreenLayoutComponent)
              },
              {
                path: 'bookings',
                loadComponent: () => import('./main/menu-account/inventory-menu/booking/booking.component').then(m => m.BookingComponent)
              },
              {
                path: '',
                redirectTo: 'media-spot',
                pathMatch: 'full'
              }
            ]
          },
          {
            path: 'subscription',
            loadComponent: () => import('./main/menu-account/subscription/subscription.component').then(m => m.SubscriptionComponent),
            children: [
              {
                path: 'active-plan',
                loadComponent: () => import('./main/menu-account/subscription/active-plan/active-plan.component').then(m => m.ActivePlanComponent)
              },
              {
                path: 'upgrade-plan',
                loadComponent: () => import('./main/menu-account/subscription/upgrade-plan/upgrade-plan.component').then(m => m.UpgradePlanComponent)
              },
              {
                path: 'my-order',
                loadComponent: () => import('./main/menu-account/subscription/my-order/my-order.component').then(m => m.MyOrderComponent)
              },
              {
                path: '',
                redirectTo: 'active-plan',
                pathMatch: 'full'
              }
            ]
          }
        ]
      },
      {
        path: '',
        redirectTo: 'welcome',
        pathMatch: 'full'
      }
    ]
  }
];
